import React, {useContext} from "react";
import {Typography, Space, Button} from "@bezlimit/bezlimit-ui";
import _ from "lodash";
import "./style.scss";
// core
import {LayoutContext, ModalContext} from "../../../core/Contexts";
//images
import attention from "../../../images/gal.png";
import {useNavigate, useParams} from "react-router-dom";

export default React.memo(function SuccessAddPassport() {
    const contextLayout = useContext(LayoutContext);
    const contextModal = useContext(ModalContext);
    const params = useParams();
    const navigate = useNavigate();

    const onClick = () => {
        contextModal?.setMaskStyle(undefined);
        contextModal?.setCssClass("");
        contextModal?.setVisible(false);
        navigate(`/reservation`);
    };

    return (
        <Typography as="div" className="bl-important">
            <Space
                size={_.gte(contextLayout?.width ?? 0, 768) ? 32 : 18}
                direction="vertical"
                align="center"
            >
                {_.gte(contextLayout?.width ?? 0, 768) ? (
                    <img src={attention} width={276} alt="attention" />
                ) : (
                    <img src={attention} width={138} alt="attention" />
                )}

                <Typography as="div" className="title">
                    {"Поздравляем, все данные \nуспешно внесены \nи отправлены!"}
                </Typography>
                {/* {_.gte(contextLayout?.width ?? 0, 768) ? (
                    <Typography as="div" className="text">
                        {
                            "Проверка займет не более часа, \nно в редких случаях может занять \nнемного больше времени."
                        }
                    </Typography>
                ) : (
                    <Typography as="div" className="text">
                        {
                            "Проверка займет не более часа, \nно в редких случаях может \nзанять немного больше времени."
                        }
                    </Typography>
                )} */}

                <Button type="primary" onClick={onClick}>
                    Вернуться в Брони
                </Button>
            </Space>
        </Typography>
    );
});
